import {
    FETCH_ALL_MARKETING_INITIATIVES,
    FETCH_ALL_MARKETING_INITIATIVES_ERROR,
    FETCH_ALL_MARKETING_INITIATIVES_SUCCESS,
    SAVE_MARKETING_INITIATIVE,
    SAVE_MARKETING_INITIATIVE_ERROR,
    SAVE_MARKETING_INITIATIVE_SUCCESS,
    DELETE_MARKETING_INITIATIVE,
    DELETE_MARKETING_INITIATIVE_ERROR,
    DELETE_MARKETING_INITIATIVE_SUCCESS,
    ENABLE_DISABLE_MARKETING_INITIATIVE,
    ENABLE_DISABLE_MARKETING_INITIATIVE_ERROR,
    ENABLE_DISABLE_MARKETING_INITIATIVE_SUCCESS,
    FETCH_ONE_MARKETING_INITIATIVE,
    FETCH_ONE_MARKETING_INITIATIVE_ERROR,
    FETCH_ONE_MARKETING_INITIATIVE_SUCCESS
} from "../constants/ActionTypes";


const initialState = {
    initiatives: [],
    error: null,
    loading: false,
    initiative: null
}

export default function marketingInitiativeReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ALL_MARKETING_INITIATIVES:
        case SAVE_MARKETING_INITIATIVE:
        case DELETE_MARKETING_INITIATIVE:
        case ENABLE_DISABLE_MARKETING_INITIATIVE:
        case FETCH_ONE_MARKETING_INITIATIVE:
            return { ...state, loading: true };
        case FETCH_ALL_MARKETING_INITIATIVES_SUCCESS:
            return { ...state, loading: false, initiatives: action.payload };
        case FETCH_ONE_MARKETING_INITIATIVE_SUCCESS:
            return { ...state, loading: false, initiative: action.payload };
        case ENABLE_DISABLE_MARKETING_INITIATIVE_SUCCESS:
            return {
                ...state, loading: false, initiatives: state.initiatives.map(initiative => {
                    if (initiative.id === action.payload.id) {
                        return {
                            ...initiative,
                            is_active: action.payload.is_active
                        }
                    }

                    return initiative;
                })
            };
        case SAVE_MARKETING_INITIATIVE_SUCCESS:
            return { ...state, loading: false, initiatives: [...state.initiatives, action.payload] };
        case FETCH_ALL_MARKETING_INITIATIVES_ERROR:
        case SAVE_MARKETING_INITIATIVE_ERROR:
        case DELETE_MARKETING_INITIATIVE_ERROR:
        case ENABLE_DISABLE_MARKETING_INITIATIVE_ERROR:
        case FETCH_ONE_MARKETING_INITIATIVE_ERROR:
            return { ...state, loading: false, error: action.payload };
        case DELETE_MARKETING_INITIATIVE_SUCCESS:
            return {
                ...state,
                loading: false,
                initiatives: state.initiatives.filter(initiative => initiative.id !== action.payload)
            };
        default:
            return state;
    }
}
